/* eslint-disable no-param-reassign */
import WebComponent from "../../common/WebComponent";
// eslint-disable-next-line no-unused-vars
import {CodeEingabe} from "../code-eingabe/main";
// eslint-disable-next-line import/no-cycle
import {updateContent} from "../../common/updateContent";

async function onCheckCodeEvent(context, event) {
    const {downloadCode, done} = event.detail;
    context.codeEingabe = context.content.firstElementChild;
    history.pushState({downloadCode}, "", `?downloadCode=${downloadCode}`);
    try {
        await updateContent(context);
        done();
    } catch (error) {
        done(error);
    }
}

async function onRedeemProductEvent(context, event) {
    const {downloadCode, checkoutId, done} = event.detail;
    context.codeEingabe = context.content.firstElementChild;
    history.pushState({downloadCode, checkoutId}, "", `?downloadCode=${downloadCode}`);
    try {
        await updateContent(context);
        done();
    } catch (error) {
        done(error);
    }
}

export class DownloadcodePage extends WebComponent {
    static get tagName() {
        return "downloadcode-page";
    }

    connectedCallback() {
        this.content = this.querySelector(".content");
        this.bestellenSnippetContainer = this.querySelector(".bestellen-snippet");

        this.addListener(window, "popstate", () => updateContent(this));
        this.addListener(this.content, "check-code", (event) => onCheckCodeEvent(this, event));
        this.addListener(this.content, "redeem-product", (event) => onRedeemProductEvent(this, event));
    }
}

if (!customElements.get(DownloadcodePage.tagName)) {
    customElements.define(DownloadcodePage.tagName, DownloadcodePage);
}
